/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as types from "../../types/primitives.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * Request body for preview_misconfigured_devices.
 */
export type PreviewMisconfiguredDevicesRequestBody = {
  /**
   * Display template to preview
   */
  displayTemplate: string;
};

/** @internal */
export const PreviewMisconfiguredDevicesRequestBody$inboundSchema: z.ZodType<
  PreviewMisconfiguredDevicesRequestBody,
  z.ZodTypeDef,
  unknown
> = z.object({
  display_template: types.string(),
}).transform((v) => {
  return remap$(v, {
    "display_template": "displayTemplate",
  });
});
/** @internal */
export type PreviewMisconfiguredDevicesRequestBody$Outbound = {
  display_template: string;
};

/** @internal */
export const PreviewMisconfiguredDevicesRequestBody$outboundSchema: z.ZodType<
  PreviewMisconfiguredDevicesRequestBody$Outbound,
  z.ZodTypeDef,
  PreviewMisconfiguredDevicesRequestBody
> = z.object({
  displayTemplate: z.string(),
}).transform((v) => {
  return remap$(v, {
    displayTemplate: "display_template",
  });
});

export function previewMisconfiguredDevicesRequestBodyToJSON(
  previewMisconfiguredDevicesRequestBody:
    PreviewMisconfiguredDevicesRequestBody,
): string {
  return JSON.stringify(
    PreviewMisconfiguredDevicesRequestBody$outboundSchema.parse(
      previewMisconfiguredDevicesRequestBody,
    ),
  );
}
export function previewMisconfiguredDevicesRequestBodyFromJSON(
  jsonString: string,
): SafeParseResult<PreviewMisconfiguredDevicesRequestBody, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) =>
      PreviewMisconfiguredDevicesRequestBody$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'PreviewMisconfiguredDevicesRequestBody' from JSON`,
  );
}
